import React from "react";
import { Box, CssBaseline, Drawer, IconButton } from "@material-ui/core";
import { DashboardIcon } from "../../icons";
import { Link } from "react-router-dom";

const DRAWER_WIDTH = 70;
export const AppFrame: React.FC = ({ children }) => (
  <>
    <CssBaseline />
    <Drawer variant="permanent" anchor="left">
      <Link to={"/"}>
        <Box clone height={70} width={1}>
          <IconButton>
            <DashboardIcon />
          </IconButton>
        </Box>
      </Link>
    </Drawer>
    <Box
      width={`calc(100% - ${DRAWER_WIDTH}px)`}
      ml={DRAWER_WIDTH + "px"}
      overflow="hidden"
    >
      {children}
    </Box>
  </>
);
